import * as React from "react"

const SvgComponent = ({ text, ...props}) => (
  <svg
    // width={851}
    // height={399}
    viewBox="0 0 851 399"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <mask
        id="c"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={-257}
        y={-280}
        width={1366}
        height={706}
      >
        <path fill="url(#b)" d="M-257-280h1366v706H-257z" />
      </mask>
      <g mask="url(#c)">
        <circle cx={426} cy={426} r={185.5} stroke="url(#d)" />
        <circle opacity={0.5} cx={426} cy={426} r={265.5} stroke="#D4D4D8" />
        <circle opacity={0.3} cx={426} cy={426} r={345.5} stroke="#D4D4D8" />
        <circle opacity={0.1} cx={425} cy={426} r={425.5} stroke="#D4D4D8" />
      </g>
      <path
        d="M468.979 397.77c23.207 0 42.02-3.649 42.02-8.15s-18.813-8.15-42.02-8.15c-23.207 0-42.02 3.649-42.02 8.15s18.813 8.15 42.02 8.15Z"
        fill="#F1EAFE"
      />
      <path
        d="M449.779 317.62s23.67 29 38.65 29c20.61 0 24.25-45.74 24.25-45.74l-10.67.65s0 28.26-16.42 28.26-27.84-43.16-36.69-43.16c-19.17 0-24.73 84.95-11.68 84.95 18.52 0 23.21-42.38 23.21-42.38"
        fill="#C7AAFA"
      />
      <path
        d="M512.679 300.87s-3.64 45.74-24.25 45.74c-15 0-38.65-29-38.65-29"
        stroke="#171515"
        strokeWidth={1.12}
        strokeMiterlimit={10}
      />
      <path
        d="M502.009 301.52s0 28.26-16.42 28.26-27.84-43.16-36.69-43.16c-19.17 0-24.73 84.95-11.68 84.95 18.52 0 23.21-42.38 23.21-42.38"
        stroke="#171515"
        strokeWidth={1.12}
        strokeMiterlimit={10}
      />
      <path
        d="M496.389 308.11c-3.32 0-6.79-.09-10.33-.27-17.69-.89-32.62-3.78-44.36-8.57-11.74-4.79-20.67-11.59-26.41-20.16-5.74-8.57-8.29-19.12-7.67-31.36.62-12.24 4.25-22.47 10.8-30.43 6.55-7.96 16.05-13.8 28.27-17.39 9.74-2.86 21.41-4.32 34.67-4.32 3.32 0 6.8.09 10.34.27 17.68.9 32.61 3.78 44.36 8.57 11.75 4.79 20.66 11.59 26.37 20.16 5.71 8.57 8.3 19.13 7.68 31.36-.62 12.23-4.26 22.48-10.8 30.43-6.54 7.95-16.06 13.8-28.28 17.4-9.74 2.86-21.37 4.31-34.64 4.31Z"
        fill="#C7AAFA"
      />
      <path
        d="M481.389 196.17c3.33 0 6.76.09 10.31.27 17.707.9 32.433 3.743 44.18 8.53 11.747 4.787 20.453 11.453 26.12 20 5.673 8.52 8.2 18.853 7.58 31-.62 12.147-4.18 22.163-10.68 30.05-6.5 7.893-15.833 13.63-28 17.21-9.74 2.86-21.247 4.29-34.52 4.29-3.32 0-6.76-.09-10.3-.27-17.707-.887-32.433-3.727-44.18-8.52-11.747-4.793-20.453-11.46-26.12-20-5.667-8.507-8.193-18.84-7.58-31 .613-12.16 4.17-22.193 10.67-30.1 6.5-7.9 15.833-13.637 28-17.21 9.733-2.86 21.237-4.293 34.51-4.3l.01.05Zm-.01-1.17c-13.32 0-25 1.46-34.83 4.34-12.26 3.68-21.92 9.59-28.53 17.68-6.61 8.09-10.31 18.39-10.93 30.75-.62 12.36 2 23 7.77 31.71s14.72 15.51 26.62 20.36 26.8 7.71 44.55 8.61c3.55.18 7 .27 10.36.27 13.32 0 25-1.46 34.83-4.34 12.33-3.62 21.93-9.53 28.55-17.57 6.62-8.04 10.3-18.4 10.93-30.76.63-12.36-2-23-7.77-31.7s-14.73-15.51-26.63-20.37c-11.9-4.86-26.8-7.71-44.55-8.61-3.54-.18-7-.27-10.36-.27l-.01-.1Z"
        fill="#171515"
      />
      <path
        d="m522.379 253.07-55.05 23.5 2.66-52.44 52.39 28.94Z"
        fill="#171515"
      />
      <path
        d="M513.549 350.79c-8.21-38-31.4-50.64-31.4-50.64l-9.34 1.37c17.6 11.36 23.49 36 25.25 46.47.434 2.626.615 5.289.54 7.95-.21 7.3.3 34.63 6.9 37.05 6.6 2.42 54.27-31.89 48.47-44.45-9.66-18.36-42.84-9.82-45.73 16.27"
        fill="#C7AAFA"
      />
      <path
        d="M508.289 364.81c2.89-26.09 36.07-34.63 45.73-16.27 5.8 12.56-41.87 46.86-48.47 44.45-6.6-2.41-7.11-29.75-6.9-37.05a41.423 41.423 0 0 0-.54-7.95c-1.76-10.49-7.65-35.11-25.25-46.47"
        stroke="#171515"
        strokeWidth={1.12}
        strokeMiterlimit={10}
      />
      <path
        d="M553.289 348.38c-11.15 1.78-44.28 29.06-48 44.57M482.149 300.15s23.19 12.63 31.4 50.64"
        stroke="#171515"
        strokeWidth={1.12}
        strokeMiterlimit={10}
      />
      <path
        d="M334.38 398.33c23.207 0 42.02-3.649 42.02-8.15s-18.813-8.15-42.02-8.15c-23.207 0-42.02 3.649-42.02 8.15s18.813 8.15 42.02 8.15Z"
        fill="#F1EAFE"
      />
      <path
        d="M315.17 318.18s23.68 29 38.65 29c20.62 0 28-79.83 28-79.83l-10.67.64s-3.76 62.36-20.18 62.36-27.84-43.15-36.7-43.15c-19.16 0-24.72 84.95-11.68 84.95 18.52 0 23.22-42.39 23.22-42.39"
        fill="#FFC61B"
      />
      <path
        d="M381.84 267.33s-7.4 79.83-28 79.83c-15 0-38.65-29-38.65-29"
        stroke="#171515"
        strokeWidth={1.12}
        strokeMiterlimit={10}
      />
      <path
        d="M371.17 267.97s-3.76 62.36-20.18 62.36-27.84-43.15-36.7-43.15c-19.16 0-24.72 84.95-11.68 84.95 18.52 0 23.22-42.39 23.22-42.39"
        stroke="#171515"
        strokeWidth={1.12}
        strokeMiterlimit={10}
      />
      <path
        d="M351.44 273.88c38.351 0 69.44-31.089 69.44-69.44S389.791 135 351.44 135 282 166.089 282 204.44s31.089 69.44 69.44 69.44Z"
        fill="#FFC61B"
        stroke="#171515"
        strokeWidth={1.12}
        strokeMiterlimit={10}
      />
      <path
        d="M378.95 351.35c-8.22-38-36.08-85.3-36.08-85.3l-9.34 1.36c15 18 28.17 70.64 29.93 81.14.437 2.626.614 5.289.53 7.95-.2 7.29.3 34.63 6.9 37 6.6 2.37 54.27-31.88 48.48-44.44-9.67-18.36-42.84-9.83-45.74 16.26"
        fill="#FFC61B"
      />
      <path
        d="M373.63 365.36c2.9-26.09 36.07-34.62 45.74-16.26 5.79 12.56-41.87 46.86-48.48 44.44-6.61-2.42-7.1-29.75-6.9-37a40.623 40.623 0 0 0-.53-7.95c-1.76-10.5-14.84-65.32-29.93-81.14"
        stroke="#171515"
        strokeWidth={1.12}
        strokeMiterlimit={10}
      />
      <path
        d="M418.69 348.93c-11.14 1.78-44.28 29.06-48 44.57M342.87 266.05s27.86 47.29 36.08 85.3"
        stroke="#171515"
        strokeWidth={1.12}
        strokeMiterlimit={10}
      />
      <path
        d="M364.39 184.18c9.63.76 14.74 4.6 14.74 4.6l1.18-14.7-.24-.1a71.485 71.485 0 0 0-18-4c-20.43-1.62-24.43 10.19-25 17.38l-.29 3.53-12.41-1-1 13.28 12.41 1-.53 6.64-12.39-1-1.05 13.33 12.38 1-1 13.19 18.68 1.49 1-13.22 19.52 1.53 4.76-13-23.22-1.83.52-6.62 19.5 1.55 4.77-13-23.21-1.84.11-1.29c.24-3.4.49-7.56 8.77-6.92Z"
        fill="#171515"
      />
      <rect x={395} y={80} width={225} height={64} rx={32} fill="#F1EAFE" />
      <foreignObject
        style={{
          whiteSpace: "pre",
          fontFamily: "Syne",
          fontSize: '1.1rem',
          fontWeight: 600,
          textAlign: 'center',
          display: 'grid',
          placeItems: 'center',
          color: 'black'
        }}
        x={390}
        y={102}
        width="27%"
        height="40px"
      >
        {text}
      </foreignObject>
      <path
        d="M417.923 150.999c-2 1.154-4.5-.289-4.5-2.598v-16.455c0-2.309 2.5-3.753 4.5-2.598l14.25 8.227c2 1.155 2 4.042 0 5.196l-14.25 8.228Z"
        fill="#F1EAFE"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={426}
        y1={-34}
        x2={426}
        y2={426}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9D9D9" />
        <stop offset={0.943} stopColor="#D9D9D9" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="d"
        x1={240}
        y1={426}
        x2={612}
        y2={426}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B224EF" />
        <stop offset={1} stopColor="#7F39FA" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h851v399H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgComponent
